export enum BackOfficeOverviewWidgetType {
  WINDOWS_DEVICES = "windowsDevices",
  MACOS_DEVICES = "macosDevices",
  LINUX_DEVICES = "linuxDevices",
  CUSTOMERS = "customers",
  PROTECTABLE_USERS = "protectableUsers",
  PROTECTED_USERS = "protectedUsers",
  PROTECTED_USERS_IN_PAID_WORKSPACES = "paidProtectedUsers",
  PROTECTED_USERS_REPORTED_TO_RECURLY = "paidRecurlyProtectedUsers",
}
